import { ConfigurationGroupOptionType } from 'shared-types/SpaPackage';
import { SelectOption } from './getSelectedOptionAndExperienceId';

export const formatOptionsForSelect = (options: ConfigurationGroupOptionType[]): SelectOption[] => {
  return options.map((opt) => ({
    label: opt?.name || '',
    value: String(opt?.id) || '',
  }));
};
